<template lang="pug">
  v-layout(align-start='')
    v-flex
      v-data-table.elevation-1(:headers='headers' item-key='parroquia' :items='parroquia' :search='search' sort-by='nombre' :loading='loading' loading-text='Cargando, por favor espere...')
        template(v-slot:top='')
          v-toolbar(flat='' color='primary' dark='')
            v-toolbar-title.justify-center Parroquia
            v-divider.mx-4(inset='' vertical='')
            v-spacer
            v-text-field.text-xs-center(v-model='search' label='Búsqueda' single-line='' hide-details='' color='success')
            v-spacer
            v-dialog(v-model='dialog' persistent='' max-width='40%')
              template(v-slot:activator='{ on }')
                v-btn.mx-2(v-if='validarCrear()' fab='' dark='' small='' color='success' v-on='on')
                  v-icon(dark='') mdi-plus
              v-card(color='grey_1')
                v-app-bar(dark color='primary')
                  v-toolbar-title.headline {{ formTitle }}
                v-card-text
                  v-row(dense)
                    v-col(cols='12')
                      v-card(color='white')
                        v-card-text
                          v-row(dense)
                            v-col(cols='12' sm='12' md='6')
                              v-text-field#nombreParroquia(dense='' outlined='' v-model='editedItem.nombre' label='Nombre')
                            v-col(cols='12' sm='12' md='6')
                              v-autocomplete(dense='' outlined='' v-model='editedItem.idMunicipio' :items='idMunicipioArray' label='Municipio')
                v-card-actions
                  v-spacer
                  v-btn(color='error' small='' dark='' @click='close')
                    v-icon mdi-close
                    | Cancelar
                  v-btn(color='success' small='' dark='' @click='save')
                    v-icon mdi-content-save
                    | Guardar
        template(v-slot:no-data='')
          h1 No hay datos de Parroquias Asociados

</template>

<script>
import Api from '@/services/methods'

export default {
  data: () => ({
    dialog: false,
    loading: true,
    headers: [
      {
        text: 'Nombre',
        align: 'center',
        value: 'nombre'
      },
      { text: 'Municipio asociado', align: 'center', value: 'codMunicipio.nombre' }
      // { text: "Acciones", value: "action", align: "right", sortable: false }
    ],
    parroquia: [],

    municipio: [],
    idMunicipioArray: [],

    search: '',
    permisosRuta: {},
    editedIndex: -1,
    editedItem: {
      nombre: '',
      idParroquia: ''
    },
    defaultItem: {
      nombre: '',
      idParroquia: ''
    }
  }),

  computed: {
    formTitle () {
      return this.editedIndex === -1
        ? 'Nueva Parroquia'
        : 'Modificar Parroquia'
    }
  },

  watch: {
    dialog (val) {
      val || this.close()
    }
  },

  created () {
    this.initialize()
  },

  methods: {
    initialize () {
      this.listarParroquias()
      this.listarMunicipios()
      /* this.permisosRuta = this.$store.state.empresa[0].permisos.find(
                             permiso => permiso.ruta == "Ruta") */
    },

    validarCrear () {
      /* return this.permisosRuta.accion.includes('Crear') */
      return true
    },

    validarModificar () {
      /* return this.permisosRuta.accion.includes('Modificar') */
      return true
    },

    validarEliminar () {
      /* return this.permisosRuta.accion.includes('Eliminar') */
      return true
    },

    listarParroquias () {
      Api.get('parroquia')
        .then(response => {
          this.parroquia = response.data
          this.loading = false
        })
        .catch(e => {
          console.log('error' + e)
          this.permissDenied(e.response.status)
        })
    },

    listarMunicipios () {
      Api.get('/municipio')
        .then(response => {
          this.municipio = response.data
          this.municipio.map(data => {
            this.idMunicipioArray.push({
              text: data.nombre,
              value: data._id
            })
          })
        })
        .catch(e => {
          console.log('error' + e)
        })
    },

    /* editItem(item) {
      this.editedIndex = this.parroquia.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    }, */

    /* deleteItem(item) {
      console.log(item);
      const index = this.parroquia.indexOf(item);
      this.$swal({
        icon: "warning",
        title: "¿Seguro que quiere borrar?",
        text: "No podrá revertir",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Si, borrar",
        cancelButtonText: "cancelar"
      }).then(result => {
        if (result.value) {
          this.$swal("Borrado!", "Su registro fue borrado.", "success");
          this.parroquia.splice(index, 1);
          Api.delete("/parroquia/" + item._id).then(response => {
            console.log(response);
          });
        }
      });
    }, */

    close () {
      this.dialog = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },

    validarCampos () {
      if (
        this.editedItem.nombre === '' ||
           this.editedItem.parroquia === ''
      ) {
        this.$swal({
          icon: 'error',
          title: 'Formulario incompleto',
          text: 'Por favor llene el campo para continuar'
        })
        return true
      } else
      if (
        this.editedItem.nombre.length > 50
      ) {
        this.$swal({
          icon: 'error',
          title: 'Error!',
          text: 'Ha excedido el limite de caracteres'
        })
        return true
      }
      return false
    },

    permissDenied (status) {
      if (status === '403') {
        this.$swal({
          icon: 'error',
          title: 'Permiso denegado',
          text: 'No tiene pemisos suficientes para ver esta página',
          allowOutsideClick: false,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'ok',
          onAfterClose: () => {
            window.location.href = '/home'
          }
        })
      }
    },

    save () {
      if (!this.validarCampos()) {
        if (this.editedIndex > -1) {
          Api.put('parroquia', this.editedItem)
            .then(response => {
              this.$swal({
                icon: 'success',
                title: 'Modificacion exitosa',
                text: 'Todos los cambios han sido efectuados'
              })
              this.listarParroquias()
              this.close()
            })
            .catch(e => {
              this.$swal({
                icon: 'error',
                title: 'Error al modificar',
                text: 'Por favor, verifique los datos e intente de nuevo'
              })
            })
          Object.assign(this.parroquia[this.editedIndex], this.editedItem)
        } else {
          Api.post('parroquia', {
            nombre: this.editedItem.nombre,
            codMunicipio: this.editedItem.idMunicipio
          })
            .then(response => {
              this.$swal({
                icon: 'success',
                title: 'Inclusion exitosa',
                text: 'Todos los datos han sido guardados'
              })
              this.parroquia.push(response.data)
              this.listarParroquias()
              this.close()
            })
            .catch(e => {
              console.log('error' + e)
              this.$swal({
                icon: 'error',
                title: 'Error al guardar',
                text: 'Por favor, verifique los datos e intente de nuevo'
              })
            })
        }
      }
    }
  }
}
</script>
